import axios from "axios";

const AuthAPI = {
	login: (code: String): Promise<any> =>
		axios.post(`/api/auth/v1/login`, {}, { params: { code } }),
	logoff: (): Promise<any> => axios.post(`/api/auth/v1/logoff`),
};

export default AuthAPI;
